export default __webpack_public_path__ + "static/media/twitter-white.83dec275.svg";